import {delay} from './runWhile'

/**
 * Retries a function invocation by the number of retries when retries are exceeded the last error is thrown
 * @param func Function which is retried
 * @param retries Number of retries before the operation fails
 * @param retryDelay Delay in milliseconds before each retry
 * @returns the result of the function invocation if successful
 */
export const retry = async <T>(func: () => Promise<T>, retries = 3, retryDelay = 1000): Promise<T> => {
    let latestError: unknown = undefined
    do {
        try {
            return await func()
        } catch (error) {
            latestError = error

            if (retries < 1) throw error

            --retries

            await delay(retryDelay)
        }
    } while (retries >= 0)

    throw latestError
}
